<template>
  <ClientOnly>
    <el-dialog
      v-model="dialogVisible"
      :class="$style['complete-info-dialog']"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="完善资料"
      width="600px">
      <el-steps
        :active="activeStep"
        align-center
        style="margin-bottom: 30px">
        <el-step title="基础资料"></el-step>
        <el-step title="关注行业"></el-step>
      </el-steps>
      <div
        v-show="activeStep === 0"
        :class="$style['complete-input']">
        <!-- <el-form
          ref="complete"
          label-width="80px"
          :model="formObj"
          :rules="rules"
        >
          <el-form-item
            :class="$style['head_right']"
            prop="avatar"
            required
          >
            <el-upload
              :class="$style['avatar-uploader']"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :http-request="handleUpload"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="formObj.avatar"
                :src="formObj.avatar"
                :class="$style['avatar']"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item  prop="nickName" required>
            <el-input
              v-model="formObj.nickName"
              placeholder="请输入昵称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="companyName" required>
            <el-input
              v-model="formObj.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item  prop="position" required>
            <el-input
              v-model="formObj.position"
              placeholder="请输入职务"
            ></el-input>
          </el-form-item>
          <el-form-item prop="companyProduct" required>
            <el-input
              v-model="formObj.companyProduct"
              placeholder="请输入公司产品"
            ></el-input>
          </el-form-item>
        </el-form> -->
        <el-upload
          :before-upload="beforeAvatarUpload"
          :class="$style['avatar-uploader']"
          :http-request="handleUpload"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
          action="https://jsonplaceholder.typicode.com/posts/">
          <img
            v-if="formObj.avatar"
            :class="$style['avatar']"
            :src="formObj.avatar" />
          <div
            v-else
            class="el-upload__text">
            <p><i class="el-icon-plus avatar-uploader-icon"></i></p>
            <p>请上传头像</p>
          </div>
        </el-upload>
        <div>
          <el-input
            v-model="formObj.nickName"
            placeholder="请输入用户名"></el-input>
        </div>
        <div>
          <el-input
            v-model="formObj.companyName"
            placeholder="请输入公司名称"></el-input>
        </div>
        <div>
          <el-input
            v-model="formObj.position"
            placeholder="请输入职务"></el-input>
        </div>
      </div>

      <!-- :class="{active : data.check}" -->
      <div
        v-show="activeStep === 1"
        :class="$style['check-industry']">
        <div :class="$style['industry-left']">
          <div
            v-for="item in industry"
            :key="item.industryId"
            :class="$style['info-label']">
            <div :class="$style['info-title']">{{ item.industryName }}</div>
            <div :class="$style['info-tag']">
              <span
                v-for="data in item.children"
                :key="'children' + data.industryId"
                :class="$style['info-span']"
                :style="
                  !secondIndustry.includes(data.id) ? ' ' : 'color: #fff; background: #E50113;'
                "
                @click="getTag(data)">
                {{ data.industryName }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <div v-show="activeStep === 0">
            <el-button @click="hide">下次再完善</el-button>
            <el-button
              type="primary"
              @click="handleNext">
              下一步
            </el-button>
          </div>
          <div v-show="activeStep === 1">
            <el-button @click="handlePrev">上一步</el-button>
            <el-button
              type="primary"
              @click="submit">
              提 交
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </ClientOnly>
</template>

<script lang="ts">
  import { defineComponent, onMounted, reactive, ref } from 'vue'
  // import { HttpRequestOptions } from 'element-plus';
  import _ from 'lodash'
  import { uploadFile } from '~/utils/oss'
  import { ResponseCode } from '~/utils/constant'
  import { useGlobalStore } from '~/stores/global'
  import type { UploadRequestOptions } from 'element-plus/es/components/upload/src/upload'
  import { fetchEditMyIndustry, fetchEditUserInfo, fetchMyIndustry } from '~/api/user'
  import { fetchIndustryGetAll } from '~/api/industry'

  export default defineComponent({
    name: 'CompleteInfo',
    setup() {
      const route = useRoute()
      const router = useRouter()
      const globalStore = useGlobalStore()

      const dialogVisible = ref(false)
      const activeStep = ref(0)
      const industry = ref<any[]>([])
      const subIndustry = ref<any[]>([])
      const firstIndustry = ref<any[]>([])
      const secondIndustry = ref<any[]>([])
      const industryList = ref<any[]>([])
      const langApi = ref('en')

      const formObj = reactive<any>({
        avatar: '',
        nickName: '',
        companyName: '',
        email: '',
        position: '',
        companyIndustry: ''
      })

      const validateNickname = (_rule: any, value: string, callback: (param?: Error) => void) => {
        const phoneRegex = /1[3-9]\d{9}/g
        const landlineRegex = /((\+?\d{1,3}-?)?0\d{2,3}-?\d{2,3})\d{2,3}(-?\d{1,4}|$)/g
        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
        const specialCharRegex = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/g

        if (
          phoneRegex.test(value) ||
          landlineRegex.test(value) ||
          emailRegex.test(value) ||
          specialCharRegex.test(value)
        ) {
          callback(new Error('昵称不能包含手机号、电话号、邮箱或包含特殊字符'))
        } else {
          callback()
        }
      }

      const show = () => {
        dialogVisible.value = true
        getMyIndustry()

        if (industry.value.length === 0) {
          fetchIndustry()
        }
      }

      const hide = () => {
        try {
          dialogVisible.value = false
        } catch (e) {
          //   console.log('用户社区完善资料235-235', e);
        }
        const redirect = _.get(this, '$route.query.redirect')
        dialogVisible.value = false
        Object.assign(formObj, {
          avatar: '',
          nickName: '',
          companyName: '',
          region: '',
          industry: ''
        })
        if (redirect) {
          router.push(redirect)
        }
      }

      const handleAvatarSuccess = (res: any) => {
        formObj.avatar = res
      }

      const beforeAvatarUpload = (file: any) => {
        const isJPG = /image/.test(file.type)
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          ElMessage.error('上传图片只能是图片格式!')
        }
        if (!isLt2M) {
          ElMessage.error('上传图片大小不能超过 2MB!')
        }
        // 直接返回false, 无法阻止上传
        if (isJPG && isLt2M) {
          return Promise.resolve()
        } else {
          return Promise.reject(new Error())
        }
      }

      const handleUpload = async (option: UploadRequestOptions) => {
        const file = option.file
        return await uploadFile(file)
      }

      const getTag = (data: any) => {
        data.check = !data.check
      }

      const submit = async () => {
        industry.value.forEach((item: any) => {
          item.children.forEach((item1: any) => {
            if (item1.check) {
              industryList.value.push(item1.id)
            }
          })
        })
        if (formObj && formObj.avatar === '') {
          ElMessage.error('请上传头像')
          return
        }
        if (formObj && formObj.nickName === '') {
          ElMessage.error('请填写昵称')
          return
        }
        if (formObj && formObj.companyName === '') {
          ElMessage.error('请填写公司名称')
          return
        }
        if (formObj && formObj.position === '') {
          ElMessage.error('请填写职务')
          return
        }
        if (industryList.value && industryList.value.length === 0) {
          ElMessage.error('请选择关注行业')
          return
        }
        await fetchEditIndustry()
        formObj.companyIndustry = 0
        const res = await fetchEditUserInfo(formObj)
        if (res?.code === ResponseCode.SUCCESS) {
          ElMessage.success('操作成功!')
          globalStore.setUser(Object.assign(globalStore.user, formObj))
          hide()
        }
      }

      const handlePrev = () => {
        activeStep.value--
      }

      const handleNext = () => {
        activeStep.value++
      }

      const fetchIndustry = async () => {
        const res = await fetchIndustryGetAll({ locale: langApi.value })

        if (res?.code === ResponseCode.SUCCESS) {
          res?.data.forEach((item: any) => {
            item.children.forEach((item1: any) => {
              item1.check = false
            })
          })
          industry.value = res?.data
          firstIndustry.value = [res?.data[0].industryId]
          subIndustry.value = res?.data[0].children
        }
      }

      const getMyIndustry = async () => {
        const res = await fetchMyIndustry()

        if (res?.code === ResponseCode.SUCCESS) {
          secondIndustry.value = secondIndustry.value.concat(
            res?.data.map((d: any) => +d.industryId)
          )
        }
      }

      const fetchEditIndustry = async () => {
        await fetchEditMyIndustry({ industryList: industryList.value })
      }

      onMounted(() => {
        const lang = route.query.lang
        if (lang == 'zh') langApi.value = 'cn'
        if (lang == 'en') langApi.value = 'en'
        const { user } = globalStore
        Object.assign(formObj, {
          avatar: user.avatar,
          nickName: user.nickName,
          companyName: user.companyName,
          email: user.email,
          position: user.position,
          companyIndustry: user.companyIndustry
        })
        // console.log('CompleteInfo onMounted');
      })

      return {
        dialogVisible,
        activeStep,
        industry,
        subIndustry,
        firstIndustry,
        secondIndustry,
        formObj,
        industryList,
        langApi,
        show,
        hide,
        handleAvatarSuccess,
        beforeAvatarUpload,
        handleUpload,
        getTag,
        submit,
        handlePrev,
        handleNext,
        fetchIndustry,
        getMyIndustry,
        fetchEditIndustry
      }
    }
  })
</script>

<style lang="less" module>
  .complete-info-dialog {
    .complete-input {
      width: 80%;
      margin: auto;

      > div {
        margin-bottom: 20px;
      }
    }

    .check-industry {
      display: flex;
      max-height: 432px;

      .industry-left {
        overflow: auto;

        .info-label {
          margin-bottom: 10px;

          .info-title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .info-tag {
            .info-span {
              cursor: pointer;
              font-size: 12px;
              margin: 4px;
              display: inline-block;
              text-align: center;
              padding: 8px 4px 0 4px;
              width: 124px;
              height: 30px;
              background: #eee;
              border-radius: 4px;
              // &.active{
              //   color: #fff;
              //   background: #E50113;
              // }
            }
          }
        }
      }

      :global {
        .el-checkbox-group {
          display: flex;
          flex-direction: column;

          .el-checkbox {
            margin-bottom: 8px;
            margin-right: 0;
          }
        }
      }
    }

    :global {
      .el-step__head.is-process,
      .el-step__title.is-process {
        color: @app-color;
      }

      .el-step__title {
        font-size: 14px;
      }

      .el-step__head.is-process {
        border-color: @app-color;
      }
    }
  }

  .avatar-uploader {
    height: 100px;
    width: 100px;
    border: 1px dashed #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;

    :global {
      .el-upload {
        width: 100%;
        height: 100%;
        display: flex !important;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
          width: 85px;
          height: auto;
        }
      }
    }
  }
</style>
